
import { PropType, RendererElement, RendererNode, VNode, computed, defineComponent, h, reactive, watch, Fragment } from 'vue';
// import { VxeTable, VxeColumn } from 'vxe-table';
import { OioPagination, OioTag } from '@kunlun/vue-ui-antd';
import { ModelFieldType, OioTable, OioColumn } from '@kunlun/dependencies';
import { isNil } from 'lodash-es';
import { DetailBaseCustomTableWidget } from './DetailBaseCustomTableWidget';
import ActionRender from './components/ActionRender.vue';
export default defineComponent({
  name: 'TradeOrderItemDetail',
  components: { ActionRender },
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    mountedFlag: {
      type: Boolean,
      default: false
    },
    _instance: {
      type: Object as PropType<DetailBaseCustomTableWidget>,
      default: () => {}
    },
    renderActionBarVNodes: {
      type: Function || null,
      default: null
    }
  },
  setup(props, ctx) {
    const state = reactive({
      dataSource: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      }
    });
    const sizeOption = [15, 30, 50, 100];
    const colunms: VNode<RendererNode, RendererElement, { [key: string]: any }>[] = [
      // h(VxeColumn, { type: 'checkbox', width: 50, fixed: 'left', align: 'center' }),
      // h(VxeColumn, { type: 'seq', title: '序号', width: 50, fixed: 'left', align: 'center' })
    ];

    const displayTableData = computed(() => {
      return state.dataSource.slice((state.pagination.currentPage - 1) * state.pagination.pageSize, state.pagination.currentPage * state.pagination.pageSize);
    });

    const genColums = () => {
      // @ts-ignore
      const displayFields = props._instance.runtimeSubviewContext.model.modelFields.filter((i) => !i.invisible);
      displayFields.forEach((field) => {
        colunms.push(
          h(
            OioColumn,
            {
              field: field.name,
              title: field.label,
              renderHeaderSlot: ((content) => field.label) as any,
              align: 'center',
              minWidth: 150,
              // sortable: true,
              // filterable: true,
              showOverflow: 'tooltip',
              showHeaderOverflow: 'tooltip',
              formatter: ({ cellValue }) => {
                return cellValue;
              }
            },
            {
              default: ({ data: row }) => {
                let realValue = row[field.name];
                // @ts-ignore
                if (field.options?.length && !isNil(realValue)) {
                  // @ts-ignore
                  if (field.multi) {
                    realValue = (field as any).options.filter((i) => !i.invisible && row[field.name].includes(i.name)).map((v) => v.displayName);
                  } else {
                    realValue = (field as any).options.filter((i) => !i.invisible).find((opt) => opt.name === row[field.name] + '')?.displayName;
                  }
                }
                if (field.ttype === ModelFieldType.Enum && realValue) {
                  if (Array.isArray(realValue)) {
                    return h(
                      'div',
                      {
                        style: {
                          display: 'flex',
                          gap: '10px',
                          'overflow-x': 'scroll',
                          width: '100%'
                        }
                      },
                      { default: () => realValue.map((r) => h(OioTag, {}, { default: () => r })) }
                    );
                  }
                  return h(OioTag, {}, { default: () => realValue });
                }
                return h('span', {}, { default: () => realValue });
              }
            }
          )
        );
      });
    };

    const stopWatch = watch(
      () => props.mountedFlag,
      (val) => {
        if (val) {
          state.dataSource = props.formData[props._instance.field.name];
          state.pagination.total = state.dataSource.length;
          genColums();
          stopWatch();
        }
      }
    );

    return () =>
      h(
        'div',
        {
          class: 'trade-order-item-detail'
        },
        [
          h('div', { class: 'actionBar-deatil' }, h(ActionRender, { renderActionVNodes: props.renderActionBarVNodes })),
          h(
            // @ts-ignore
            OioTable,
            {
              data: displayTableData.value,
              headerAlign: 'center',
              border: true,
              height: '500',
              columnConfig: { resizable: true },
              scrollY: { enabled: true, gt: 0 },
              rowConfig: {},
              tooltipConfig: { showAll: true, enterable: true }
            },
            {
              default: () => colunms
            }
          ),
          h(OioPagination, {
            current: state.pagination.currentPage,
            pageSize: state.pagination.pageSize,
            total: state.pagination.total,
            pageSizeOptions: sizeOption,
            showTotal: (total) => `${total} 条`,
            onChange(page, pageSize) {
              state.pagination.currentPage = page;
              state.pagination.pageSize = pageSize;
            },
            onShowSizeChange(current, size) {
              state.pagination.currentPage = current;
              state.pagination.pageSize = size;
            }
          })
        ]
      );
  }
});
